import clsx from 'clsx';

export default function Card({ children, className, title, action, noPad, ...props }) {
  return (
    // Consumer className is merged last so it wins on class-attribute order.
    <div className={clsx('surface-panel', !noPad && 'p-6', className)} {...props}>
      {(title || action) && (
        <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
          {title && <h3 className="text-lg font-semibold text-slate-900">{title}</h3>}
          {action}
        </div>
      )}
      {children}
    </div>
  );
}
